import { checkType, CheckType } from './shared';
import { COMALL_ELEMENT_TYPE } from './CoMallSymbols';
/**
 * 验证对象是否为 CoMall 元素
 * @param element
 */
function isValidCoMallElement(element) {
    return (checkType(element) === CheckType.Object &&
        checkType(element) !== CheckType.Null &&
        element.$$typeof === COMALL_ELEMENT_TYPE);
}
export default isValidCoMallElement;
//# sourceMappingURL=isValidCoMallElement.js.map